import { useEffect, useState } from 'react';
import { Alert } from '@mui/material';
import { requestApi } from '../api/request_api';
import type { RequestDelay } from '../types';

interface DelayExpirationBannerProps {
  requestUuid: string;
}

export const DelayExpirationBanner = ({ requestUuid }: DelayExpirationBannerProps) => {
  const [delay, setDelay] = useState<RequestDelay | null>(null);

  useEffect(() => {
    requestApi.getActiveDelay(requestUuid).then(setDelay).catch(() => setDelay(null));
  }, [requestUuid]);

  if (!delay) return null;

  let formattedTime = 'a scheduled time';
  if (delay.scheduled_time) {
    try {
      formattedTime = new Date(delay.scheduled_time).toLocaleString(undefined, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      });
    } catch {
      formattedTime = delay.scheduled_time;
    }
  }

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      This task has an active delay. It will reopen on <strong>{formattedTime}</strong>.
    </Alert>
  );
};
